/**
 * Imported by `main.ts` before anything else that uses the session: adopts a
 * token the router staged for this tab (`?token=` over a different session,
 * `stageTokenAdoption`) as a new login, so neither an app nor the mux ever
 * starts under the old credentials. Expired or malformed entries are deleted.
 */
import { adoptPendingToken } from './auth';

adoptPendingToken();
